import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../../../components/Header';
import FooterTwo from '../../../../components/Footer';
import './ImportantCriteria.scss';
import { Link } from 'react-router-dom';
import PageBanner from '../../../../components/PageBanner';
import './ExtendedProfile.scss'; // Import the global glass tabs/carousel styling

import { mediaUrl } from '../../../../services/assetUrl';

const API_BASE = process.env.REACT_APP_DATABASEURL || '';

const ImportantCriteriaSection = ({ section, isActive, onToggle }) => {
  const [activeCriteria, setActiveCriteria] = React.useState(section.rows[0]?.criteria);

  React.useEffect(() => {
    if (isActive && section.rows.length > 0) {
      setActiveCriteria(section.rows[0].criteria);
    }
  }, [isActive, section]);

  const activeRow = section.rows.find(row => row.criteria === activeCriteria) || section.rows[0];

  return (
    <div className={`ep-accordion-item ${isActive ? 'is-active' : ''}`}>
      <button 
        className="ep-accordion-header"
        onClick={onToggle}
        aria-expanded={isActive}
      >
        <div className="ep-accordion-header__left">
          <span className="ep-accordion-badge">CRITERIA {section.id}</span>
          <h2 className="ep-accordion-title">
            {section.title || `Details for Criteria ${section.id}`}
          </h2>
        </div>
        <div className="ep-accordion-header__right">
          <svg 
            className={`ep-accordion-icon ${isActive ? 'rotate' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      {isActive && (
        <div className="ep-accordion-body tab-fade-in p-6 bg-white">
          {/* Glass UI Tabs */}
          <div className="ep-tabs-container">
            {section.rows.map((row) => (
              <button
                key={row.criteria}
                onClick={() => setActiveCriteria(row.criteria)}
                className={`ep-tab ${activeCriteria === row.criteria ? 'ep-tab--active' : ''}`}
              >
                {row.criteria}
              </button>
            ))}
          </div>

          {/* Key Aspects Info (Optional addition to make it look cool) */}
          {activeRow?.keyAspects && (
            <div style={{
              marginBottom: '24px', 
              padding: '16px', 
              borderRadius: '12px', 
              backgroundColor: '#eff6ff', 
              border: '1px solid #dbeafe', 
              color: '#1e3a8a', 
              fontSize: '0.875rem', 
              fontWeight: '500'
            }}>
              <span style={{ fontWeight: '700', marginRight: '8px', color: '#1d4ed8' }}>Key Aspects:</span> 
              {activeRow.keyAspects}
            </div>
          )}

          {/* Active Tab Content - Carousel */}
          <div className="ep-carousel">
            {activeRow?.resources?.map((res, resIndex) => (
              <div key={resIndex} className="ep-carousel-item">
                <span className="ep-carousel-item__year">{res.text}</span>
                {res.href || res.localHref ? (
                  <a
                    href={mediaUrl(res.localHref || res.href)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ep-carousel-item__link"
                    title="View PDF"
                  >
                    <svg className="ep-carousel-item__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                    </svg>
                    <span>View Document</span>
                  </a>
                ) : (
                  <span className="ep-carousel-item__link ep-carousel-item__link--disabled">
                    <span>Updating Soon</span>
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ImportantCriteria = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [importantCriteriaData, setImportantCriteriaData] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}api/iqac-details/important-criteria`);
        const data = res?.data?.data?.data;
        if (active && Array.isArray(data)) setImportantCriteriaData(data);
      } catch (e) {
        // leave empty on failure
      }
    })();
    return () => { active = false; };
  }, []);

  return (
    <div className="ic-page">
      <Header />
      
      {/* Hero Section */}
      <PageBanner
        title="Important Criteria"
        eyebrow="QUALITY ASSURANCE"
        subtitle="NAAC CRITERIA 1 TO CRITERIA 7 DOCUMENTATION"
      >
        <div style={{ marginTop: '32px' }}>
          <a href="/iqac-overview" className="ic-hero__bar-button" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', backgroundColor: '#F6872A', color: 'white', borderRadius: '8px', fontWeight: 'bold', textDecoration: 'none' }}>
            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd"></path>
            </svg>
            View Full IQAC Overview
          </a>
        </div>
      </PageBanner>

      {/* Main Content */}
      <main className="ic-main">
        <div className="ic-cinematic-container">

          <div className="ep-accordion-list">
            {importantCriteriaData.map((section) => (
              <ImportantCriteriaSection 
                key={`section-${section.id}`}
                section={section}
                isActive={activeTab === section.id}
                onToggle={() => setActiveTab(activeTab === section.id ? null : section.id)}
              />
            ))}
          </div>

        </div>
      </main>

      <FooterTwo />
    </div>
  );
};

export default ImportantCriteria;
